import RichMenuService from "./rich-menu.service";
import CategoriesServices from "./categories.service";
import SystemSettingsService from "./system-settings.service";
import StampService from "services/stamp.service";

export const richMenuService = new RichMenuService();
export const categoriesService = new CategoriesServices();
export const systemSettingsService = new SystemSettingsService();
export const stampService = new StampService();
